import axiosInstance from "../configs/axios/axiosInstance";
const CustomerOrdersServices = {

    getOrdersList: async (filters: any) => {
        const response = await axiosInstance.get('Order/GetOrderHeaderList', { params: filters });
        return response.data;
    },

    getOrderDetails: async (orderId: string, userId: string) => {
        const params = { orderID: orderId, userID:userId };
        const response = await axiosInstance.get('Order/GetOrderDetails', { params: params });
        return response.data;
    },

    uploadOrderFile: async (payload: any) => {
        const response = await axiosInstance.post('Order/UploadFile', payload, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        return response.data;
    },

    uploadOrdersFromFile: async (payload: any) => {
        const response = await axiosInstance.post('Order/UploadOrder', payload, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        return response.data;
    },

    getFilterData: async (filterType: string, userId: string) => {
        const params = { filterType, userId };
        const response = await axiosInstance.get('Utilities/GetDropDownOrderGridFiltersByType', { params: params });
        return response.data;
    },

    getShipTo: async (shipToId: string) => {
        const params = { shipToId };
        const response = await axiosInstance.get('Order/xxx', { params: params });
        return response.data;
    },

    getSoldTo: async (soldToId: string) => {
        const params = { soldToId };
        const response = await axiosInstance.get('Order/xxxx', { params: params });
        return response.data;
    },

    generateRpaFiles: async (payload: any) => {
        const response = await axiosInstance.post('RPA/ExportRPATemplate', payload);
        return response.data;
    },
    
    deleteOrder: async (orderID: string) => {
        const response = await axiosInstance.put('Order/DeleteOrder', null, {
            params: { orderID },
        });
        return response.data;
    },

    multiDeleteOrders: async (orderIds: string[]) => {
        const response = await axiosInstance.put('Order/MultiOrderDelete', {
          orderIds: orderIds
        });
        return response.data;
      },

    multiUpdateOrders: async (payload: any) => {
        const response = await axiosInstance.put('Order/MultiOrderUpdate', payload);
        return response.data;
    },

};

export default CustomerOrdersServices;
